<h2 mat-dialog-title>{{ data.title }}</h2>
<div class="w-full flex items-center justify-center">
  <mat-spinner diameter="50"></mat-spinner>
</div>
